import React from 'react';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTypography from '@material-ui/core/Typography';
import { DateTime } from 'luxon';
import ButtonWithConfirmation from 'components/ButtonWithConfirmation';
import * as API from 'api';
import { useMutation } from 'react-query';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import TableSelectColumn from 'components/TableSelectColumn';

const LinkfireIngestionHistory = API.LinkfireIngestionHistory();

const LinkfireHistoryRow = ({
  file_name,
  status,
  created_at,
  records_imported,
  records_total,
  refetch,
  isSelected,
  onToggleSelect,
  isRunningFilesAgain,
}) => {
  const runFileAgain = useMutation(() => LinkfireIngestionHistory.runFileAgain([file_name]), {
    onSuccess: () => {
      refetch();
    },
    onError: error => {
      alert(error.data?.message || 'Unknown Error');
      runFileAgain.reset();
    },
  });
  const formattedFileName = file_name.split('/').pop();
  const fileNameCell = (
    <MuiTableCell align="left" title={file_name}>
      <MuiTypography>{formattedFileName}</MuiTypography>
    </MuiTableCell>
  );

  const statusCell = (
    <MuiTableCell align="center">
      <MuiTypography>{status}</MuiTypography>
    </MuiTableCell>
  );

  const createdAtCell = (
    <MuiTableCell align="left">
      <MuiTypography>
        {created_at
          ? DateTime.fromISO(created_at).toLocaleString({
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}
      </MuiTypography>
    </MuiTableCell>
  );

  const recordsImportedCell = (
    <MuiTableCell align="left">
      <MuiTypography>
        {records_imported} ({((records_imported / records_total) * 100).toFixed(2)}%)
      </MuiTypography>
    </MuiTableCell>
  );

  function handleRunAgain() {
    runFileAgain.mutate();
  }

  const actionCell = (
    <MuiTableCell align="center">
      {runFileAgain.isLoading ? (
        <MuiCircularProgress size={20} color="primary" />
      ) : (
        <ButtonWithConfirmation
          disabled={isRunningFilesAgain}
          variant="contained"
          size="small"
          buttonText="Run Again"
          dialogTitle="Run Again"
          dialogContent="Are you sure you want to run this file again?"
          onSubmit={handleRunAgain}
        />
      )}
    </MuiTableCell>
  );
  return (
    <>
      <MuiTableRow>
        <TableSelectColumn checked={isSelected} onChange={onToggleSelect} tooltip="Select this file" />
        {fileNameCell}
        {statusCell}
        {createdAtCell}
        {recordsImportedCell}
        {actionCell}
      </MuiTableRow>
    </>
  );
};

export default LinkfireHistoryRow;
